module.exports = __webpack_public_path__ + "media/images/icons/flags/TN-11d044ca9384fa80a31c924b96f839d3.svg";